import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { SearchBarComponentModule } from '../search-bar/search-bar.component';
import { CommonModule } from '@angular/common';
import { TokenPaginatorComponentModule } from '../token-paginator/token-paginator.component';

@Component({
    selector: 'ts-paginated-search-header',
    templateUrl: './paginated-search-header.component.html',
    styleUrls: ['./paginated-search-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PaginatedSearchHeaderComponent<T> {
  @Input() searchValue: string;
  @Input() previousTokens: T[];
  @Input() lastItem: T;
  @Input() length: number;
  @Input() pageSize: number;
  @Input() pageSizeOptions: number[];
  @Input() disabled: boolean;
  @Input() counting: boolean;

  @Output() searchChanged = new EventEmitter<string>();
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() pageSizeChange = new EventEmitter<number>();
}

@NgModule({
  declarations: [PaginatedSearchHeaderComponent],
  exports: [PaginatedSearchHeaderComponent],
  imports: [CommonModule, SearchBarComponentModule, TokenPaginatorComponentModule],
})
export class PaginatedSearchHeaderComponentModule {}
